module.exports = "/_next/static/images/00a603231290a42ca0439e92b1a04a80-nubanker-ds@0.5x.jpg.webp";